type SessionExpiredListener = () => void

let isExpiredFlag = false
const listeners: Set<SessionExpiredListener> = new Set()

export const sessionEvents = {
  isExpired(): boolean {
    return isExpiredFlag
  },

  notifySessionExpired() {
    if (isExpiredFlag) return
    isExpiredFlag = true
    for (const listener of listeners) {
      try {
        listener()
      } catch (err) {
        // NOSONAR: Logging listener errors prevents unhandled crashes in event dispatching
        // eslint-disable-next-line no-console
        console.error('Session expired listener error:', err) // NOSONAR
      }
    }
  },

  subscribe(listener: SessionExpiredListener) {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },

  reset() {
    isExpiredFlag = false
  },
}
